import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap, tap } from 'rxjs';
import { ContactGrouopService } from 'src/app/private/services/contact-groups.service';
import { TeamService } from 'src/app/private/services/teams.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.scss']
})
export class TeamListComponent {

  pageSizeOptions: number[] = [10, 25, 100];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  btnLoading = false;
  initialLoad2 = true;
  // isRefresh = false;
  @Input() isRefresh: any;
  @Output() handleSetuser = new EventEmitter<any>();


  editData: any;
  displayedColumns: string[] = [
    "sno",
    "name",
    "email",
    "actions"
  ];


  @Input() currentSelectedContactGroupID: any;
  @Input() GroupListData: any;
  @Input() currentPage: any;
  @Input() pageSize: any;
  @Input() totalRows: any;
  @Input() dataSource: any;
  @Input() initialLoad: any;
  @Input() relaodTeamTable: any;

  constructor(
    private toast: ToastrService,
    private api: TeamService,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private tracker: TrackingService,
  ) {

  }


  // ngAfterViewInit() {
  //   if (this.currentSelectedContactGroupID) {
  //     this.loadData();
  //   }
  // }

  ngOnChanges() {
    if (this.currentSelectedContactGroupID) {
      this.loadData();
    }else{
      this.dataSource = new MatTableDataSource<any>([]);
      this.totalRows = 0;
      this.initialLoad2 = false;
      this.isRefresh = false;
    }

  }

  loadData(type?: string) {
    console.log("currentSelectedTeamId", this.currentSelectedContactGroupID)

    try {
      // this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        this.sort.sortChange,
        this.paginator.page
      )
        .pipe(
          startWith({}),
          tap(() => {
            console.log("🔁 Stream triggered by a value change");
          }),
          switchMap(() => {
            this.isRefresh = true;

            const clientId = this.localStorage.getClientId();
            const payload = {
              where: {
                client_id: clientId,
                team_id: this.currentSelectedContactGroupID
              },
              filter: null,
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                col: `"team_user"."updatedAt"`,
                dir: "DESC"
              }
            };

            console.log("📦 Payload:", payload);

            return this.api.getAllTeamMembers(payload).pipe(
              catchError(err => {
                console.error("❌ API Error:", err);
                return observableOf(null);
              })
            );
          }),
          map((response: any) => {
            console.log("✅ API Response:", response);

            if (response === null) {

              return [];
            }

            this.totalRows = response.count;
            this.isRefresh = false;

            return response.rows || [];
          })
        )
        .subscribe({
          next: (data) => {
            this.initialLoad2 = false;

            console.log("🟡 initialLoad:", this.initialLoad);


            this.dataSource = new MatTableDataSource<any>(data);
            console.log("📦 MatTableDataSource:", this.dataSource);
            this.handleSetuser.emit(data);
            this.GroupListData = data;
            this.isRefresh = false;
          },
          error: (e) => {
            this.initialLoad = false;
            this.isRefresh = false;
            console.error("🚨 Subscribe error:", e);
          },
          complete: () => {
            console.log("✅ Observable complete");
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.isRefresh = false;
      console.error("🚨 Outer try/catch error:", e);
    }

  }


  reloadData(type?: string) {

    try {
      // this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(

      )
        .pipe(
          startWith({}),
          tap(() => {
            console.log("🔁 Stream triggered by a value change");
          }),
          switchMap(() => {
            this.isRefresh = true;

            const clientId = this.localStorage.getClientId();
            const payload = {
              where: {
                client_id: clientId,
                team_id: this.currentSelectedContactGroupID
              },
              filter: null,
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                col: `"team_user"."updatedAt"`,
                dir: "DESC"
              }
            };

            console.log("📦 Payload:", payload);

            return this.api.getAllTeamMembers(payload).pipe(
              catchError(err => {
                console.error("❌ API Error:", err);
                return observableOf(null);
              })
            );
          }),
          map((response: any) => {
            console.log("✅ API Response:", response);

            if (response === null) {
              return [];
            }

            this.totalRows = response.count;
            this.isRefresh = false;

            return response.rows || [];
          })
        )
        .subscribe({
          next: (data) => {
            this.initialLoad2 = false;

            console.log("🟡 initialLoad:", this.initialLoad);


            this.dataSource = new MatTableDataSource<any>(data);
            console.log("📦 MatTableDataSource:", this.dataSource);
            this.handleSetuser.emit(data);
            this.GroupListData = data;
            this.isRefresh = false;
          },
          error: (e) => {
            this.initialLoad = false;
            this.isRefresh = false;
            console.error("🚨 Subscribe error:", e);
          },
          complete: () => {
            console.log("✅ Observable complete");
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.isRefresh = false;
      console.error("🚨 Outer try/catch error:", e);
    }

  }

  resetPaginator() {
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10; // Set default pageSize or any value you want
    }
  }

  getUserName(user: any) {
    return [user.fname, user.lname].filter(Boolean).join(' ');
  }

  openDeleteUserModal(content: any, user: any) {
    this.modalService.open(content, { centered: true });
    this.editData = user;
  }

  handleDeleteUser() {
    this.btnLoading = true;
    const payload = {
      client_id: this.localStorage.getClientId(),
      team_id: this.currentSelectedContactGroupID,
      user_id: [this.editData.user_id]
    };

    this.api.deleteTeamMember(payload).subscribe({
      next: (res) => {
        this.btnLoading = false;
        this.toast.success(res.message || 'Team member deleted successfully');
        // ✅ Add tracking log here
      const desc = `Removed user with ID: ${this.editData.user_id} from team with ID: ${this.currentSelectedContactGroupID}`;
      this.tracker.track("Delete", "Team Member", desc);
        this.reloadData();
        this.modalService.dismissAll();
      },
      error: (err) => {
        this.btnLoading = false;
        this.toast.error(err.error.message || 'Something went wrong');
      }
    });
  }
}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}